import { render, staticRenderFns } from "./EditEmail.vue?vue&type=template&id=71323178&scoped=true&"
import script from "./EditEmail.vue?vue&type=script&lang=js&"
export * from "./EditEmail.vue?vue&type=script&lang=js&"
import style0 from "./EditEmail.vue?vue&type=style&index=0&id=71323178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71323178",
  null
  
)

export default component.exports